import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20artistic%20background%20with%20abstract%20geometric%20patterns%20and%20warm%20gradients%2C%20soft%20golden%20and%20rose%20color%20palette%2C%20dreamy%20atmospheric%20lighting%2C%20subtle%20motion%20blur%20effect%2C%20elegant%20composition%2C%20modern%20clean%20aesthetic%2C%20minimal%20decorative%20elements%2C%20warm%20inviting%20tone&width=1600&height=800&seq=cta-bg-main&orientation=landscape"
        alt="立即开始韩漫阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-foreground-950/40"></div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-start md:items-end justify-between gap-10">
          <div className="flex-1">
            <h2 className="text-2xl md:text-4xl font-bold text-background-50 font-heading leading-tight max-w-md">
              现在就开启你的
              <br />
              韩漫阅读之旅
            </h2>
            <div className="mt-8">
              <Link
                to="/category/love"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-950 text-sm font-medium rounded-full hover:bg-background-100 transition-all whitespace-nowrap"
              >
                免费开始阅读
                <span className="w-5 h-5 rounded-full bg-foreground-950 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-background-50 text-[10px]"></i>
                </span>
              </Link>
            </div>
          </div>
          <div className="flex-1 text-right">
            <p className="text-sm text-background-50/80 leading-relaxed max-w-xs ml-auto">
              海量正版韩漫资源，每日更新不间断，
              <br />
              随时随地畅享下拉式阅读体验
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}